import { render, staticRenderFns } from "./FormResponsePreview.vue?vue&type=template&id=5270f892&scoped=true&"
import script from "./FormResponsePreview.vue?vue&type=script&lang=js&"
export * from "./FormResponsePreview.vue?vue&type=script&lang=js&"
import style0 from "./FormResponsePreview.vue?vue&type=style&index=0&id=5270f892&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270f892",
  null
  
)

export default component.exports